export default __webpack_public_path__ + "static/media/flag-saint-vincent-and-the-grenadines.f6bf193c.svg";